import { render, staticRenderFns } from "./booking_customer_detail_tbn.vue?vue&type=template&id=ccda5b64&scoped=true&"
import script from "./booking_customer_detail_tbn.vue?vue&type=script&lang=js&"
export * from "./booking_customer_detail_tbn.vue?vue&type=script&lang=js&"
import style0 from "./booking_customer_detail_tbn.vue?vue&type=style&index=0&id=ccda5b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccda5b64",
  null
  
)

export default component.exports